export function getNormalizedAdBaiduLandingUrl(rawUrl, bdVid = '') {
  const safeBdVid = String(bdVid || '').trim()

  try {
    const url = new URL(String(rawUrl || '').trim() || window.location.href)
    url.hash = ''
    if (safeBdVid) {
      url.searchParams.set('bd_vid', safeBdVid)
    }
    url.searchParams.delete('logidUrl')
    url.searchParams.delete('logid_url')
    return url.toString()
  } catch (error) {
    const fallback = new URL('/adbaidu', window.location.origin)
    if (safeBdVid) {
      fallback.searchParams.set('bd_vid', safeBdVid)
    }
    return fallback.toString()
  }
}
